import {Component, ElementRef, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {FormControl} from '@angular/forms';
import {MatAutocompleteSelectedEvent} from '@angular/material/autocomplete';
import {trim} from 'lodash';
import {Manufacturer} from '../../api/model/manufacturer';
import {ManufacturerService} from '../../api/manufacturer.service';
import {highlightText, removeDiacritics} from '../util';

@Component({
  selector: 'app-manufacturer-autocomplete',
  templateUrl: './manufacturer-autocomplete.component.html',
  styleUrls: ['./manufacturer-autocomplete.component.sass'],
})
export class ManufacturerAutocompleteComponent {
  @Input({required: true}) control!: FormControl<string | null | undefined>;
  @Input() label = 'Manufacturer';
  @Input() placeholder = 'Ex. ETC';
  @Output() selected = new EventEmitter<Manufacturer>();

  manufacturerList = this.manufacturerService.listSignal();
  filteredManufacturers: Manufacturer[] = [];

  @ViewChild('manufacturerInput') manufacturerInput!: ElementRef<HTMLInputElement>;

  protected readonly trim = trim;

  constructor(private manufacturerService: ManufacturerService) {
  }

  filter() {
    const filterValue = removeDiacritics(this.manufacturerInput?.nativeElement.value);
    this.filteredManufacturers = this.manufacturerList()?.filter(m => removeDiacritics(m.name).includes(filterValue)) || [];
  }

  onOptionSelected($event: MatAutocompleteSelectedEvent) {
    const value = $event.option.value || '';
    if (!value) return;
    this.control.setValue(value, {emitEvent: false});
    const manufacturer = this.manufacturerList()?.find(m => m.name === value);
    if (manufacturer) {
      this.selected.emit(manufacturer);
    }
  }

  showCreateOption(): boolean {
    const inputValue = this.manufacturerInput?.nativeElement.value;
    if (!inputValue || !inputValue.trim()) return false;
    return this.manufacturerList()?.find(m => removeDiacritics(m.name) === removeDiacritics(inputValue)) === undefined;
  }

  highlight(text: string, searchFor: string | undefined | null) {
    return highlightText(text, searchFor);
  }
}
